import { matchPath } from "react-router";

import { routes } from "@/routes";

/**
 * Generate the href to switch to a project. If you are on the tickets page we want to stay
 * on the ticket page, just in a different project.
 */
export function getProjectSwitchHref(pathname: string, slug: string): string {
  if (matchPath(routes.tickets.ROOT, pathname)) {
    return routes.tickets.list({ slug });
  }

  return routes.home.home({ slug });
}
